export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9477.6f1d998b.jpg";